import React from 'react';

import "../styles/CompteRendu.scss";

const CompteRendu = ({ data, ...props }) => {


  // ----------------------------------
  // 
  // ----------------------------------
  const renderPage = (content, aside) => {
    return (
      <div className="compte-rendu">
        <div className="compte-rendu__row">
          <div className="compte-rendu__left">
            <h1 className="compte-rendu__title">Compte rendu médical</h1>
            <ul className="compte-rendu__infos" style={{ marginBottom: '1rem' }}>
              <li className="compte-rendu__info">
                <span className="label">Patient: </span> Nom, prénom
              </li>
              <li className="compte-rendu__info">
                <span className="label">Date de naissance: </span> DD/MM/YYYY
              </li>
              <li className="compte-rendu__info">
                <span className="label">Motif de la consultation: </span> Dépistage du cancer de la peau
              </li>
            </ul>
            {content}
          </div>
          <div className="compte-rendu__right">
            <h1 className="compte-rendu__title compte-rendu__title--logo">
              <div className="compte-rendu__logo"></div>
            </h1>
            <div className="compte-rendu__box">
              <ul className="compte-rendu__infos">
                <li className="compte-rendu__info">
                  <span className="label">Date: </span> DD/MM/YYYY
                </li>
                <li className="compte-rendu__info">
                  <span className="label">Heure: </span> 00:00
                </li>
              </ul>
              <hr />
              <ul className="compte-rendu__infos">
                <li className="compte-rendu__info">
                  <span className="label label--block">Lieu de consultation: </span> XXXXX
                </li>
                <li className="compte-rendu__info">
                  <span className="label label--block">Type de consultation: </span> Téléconsultation assistée
                </li>
              </ul>
              <hr />
              <ul className="compte-rendu__infos">
                <li className="compte-rendu__info">
                  <span className="label label--block">Médecin: </span> Nom du docteur, prénom du docteur
                </li>
                <li className="compte-rendu__info">
                  <span className="label label--block">Numéro RPPS: </span> xxxxxxxxxxxxxxxxxx
                </li>
              </ul>
              <hr />
              <ul className="compte-rendu__infos">
                <li className="compte-rendu__info">
                  <span className="label label--block">Soignant en présentiel: </span> Nom, prénom, Profession
                </li>
                <li className="compte-rendu__info">
                  <span className="label label--block">Numéro RPPS: </span> xxxxxxxxxxxxxxxxxx
                </li>
              </ul>
            </div>
            {aside}
          </div> 
        </div>
        <div className="compte-rendu__footer">
          <p className="compte-rendu__help">Des questions ou des remarques ? Nous sommes à votre disposition.</p>
          <p className="compte-rendu__email">
            <i className="icon-email"></i> equipe-medicale@hocoia.com
          </p>
          <p className="compte-rendu__phone">
            <i className="icon-call"></i> 01 84 67 13 00 
          </p>
        </div>
      </div>
    );
  }

  // ----------------------------------
  const renderPage1 = () => {
    return renderPage(
      (
        <>
          <h2 className="compte-rendu__subtitle">Observations médicales et diagnostic</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
            Duis aute irure dolor in reprehenderit in voluptate velit esse.</p>
          <h2 className="compte-rendu__subtitle">Prescriptions</h2>
          <p>Lorem ipsum dolor sit amet, <br />
            consectetur adipiscing elit, <br />
            sed do eiusmod tempor incididunt </p>
          <h2 className="compte-rendu__subtitle">Recommandations et suivi</h2>
          <p>Lorem ipsum dolor sit amet, <br />
            consectetur adipiscing elit, <br />
            sed do eiusmod tempor incididunt </p>
          <h2 className="compte-rendu__subtitle">Incidents pendant la consultation</h2>
          <p>Lorem ipsum dolor sit amet, <br />
            consectetur adipiscing elit, <br />
            sed do eiusmod tempor incididunt </p>
        </>
      ),
      (
        <div className="compte-rendu__box">
          <h2 className="compte-rendu__subtitle">Paramètres vitaux</h2>
          <ul className="compte-rendu__infos">
            <li className="compte-rendu__info compte-rendu__info--flex">
              <span className="label label--icon"><i className="icon-cake" /></span> 15 ans
            </li>
            <li className="compte-rendu__info compte-rendu__info--flex">
              <span className="label label--icon"><i className="icon-temp" /></span> 35.8°C
            </li>
            <li className="compte-rendu__info compte-rendu__info--flex">
              <span className="label label--icon"><i className="icon-meter" /></span> XXX cm
            </li>
            <li className="compte-rendu__info compte-rendu__info--flex">
              <span className="label label--icon"><i className="icon-weight" /></span> XX kg
            </li>
            <li className="compte-rendu__info compte-rendu__info--flex">
              <span className="label label--icon"><i className="icon-glycemie" /></span> XX mmol/L
            </li>
            <li className="compte-rendu__info compte-rendu__info--flex">
              <span className="label label--icon"><i className="icon-oxymetrie" /></span> 100%SPO²
            </li>
          </ul>
        </div>
      )
    );
  }

  // ----------------------------------
  const renderPage2 = () => {
    return renderPage(
      (
        <>
          <h2 className="compte-rendu__subtitle">Images</h2>
          <p>
            <img src='https://picsum.photos/714/390' className='img-fluid' />
            <img src='https://picsum.photos/714/390?grayscale' className='img-fluid' />
          </p>
        </>
      )
    )
  }

  // ----------------------------------
  // Render
  // ----------------------------------
  return (
    <>
      {renderPage1()}
    </>
  );
}

export default CompteRendu;